import { MantineSize, Text } from '@mantine/core';

const XSafeTextInfo = ({
  data,
  size,
  weight,
}: {
  data?: JSX.Element | string | number | null | undefined;
  size?: MantineSize;
  weight?: number;
}) => {
  return data === 'N/A' ||
    data === '.' ||
    data === 'N/S' ||
    (!data && data !== 0) ? (
    <>
      <Text size='sm' color='dimmed'>
        N/A
      </Text>
    </>
  ) : (
    <Text size={size || 'sm'} weight={weight}>
      {data}
    </Text>
  );
};

export default XSafeTextInfo;
